var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTasksIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#034CD7;}\r\n\t.st1{fill:none;stroke:#034CD7;stroke-width:3.7;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.2,96H17.7c-1.5,0-2.7-1.2-2.7-2.7V2.7c0-1.5,1.2-2.7,2.7-2.7h62.5c1.5,0,2.7,1.2,2.7,2.7v90.5 C82.9,94.8,81.7,96,80.2,96z M18.6,92.3h60.6V3.7H18.6V92.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,29.5L45.7,29.5c0-1,0.8-1.8,1.8-1.8h22.9c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8H47.6 C46.6,31.4,45.7,30.5,45.7,29.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,49.2L45.7,49.2c0-1,0.8-1.8,1.8-1.8h22.9c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8H47.6 C46.6,51.1,45.7,50.3,45.7,49.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,72.6l-1.7,1.7c-0.3,0.3-0.7,0.3-0.9,0l-5.2-5.2c-0.3-0.3-0.3-0.7,0-0.9l1.7-1.7c0.3-0.3,0.7-0.3,0.9,0 l5.2,5.2C35.7,72,35.7,72.4,35.4,72.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,74.3l-1.6-1.6c-0.3-0.3-0.3-0.7,0-1l8-8c0.3-0.3,0.7-0.3,1,0l1.6,1.6c0.3,0.3,0.3,0.7,0,1l-8,8 C33.5,74.6,33.1,74.6,32.8,74.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,69L45.7,69c0-1,0.8-1.8,1.8-1.8h22.9c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8H47.6 C46.6,70.8,45.7,70,45.7,69z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.8,
    cy: 49.2,
    r: 4.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.8,
    cy: 29.5,
    r: 4.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTasksIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TasksIcon.69a43b1f.svg";
export { ForwardRef as ReactComponent };